import React, { useEffect, useState} from 'react';
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux';
import Results from './Results';
import { getCategoryVideos, getCategoryVideosLength } from '../../actions/filterActions';

const CategoryResults = (props) => {

    const {category_title, category_id} = useParams()

    const {error, loading, categoryVideos, page, info } = useSelector(state => state.categoryVideos)
    
    const [categoryPage, setCategoryPage] = useState(page === undefined ? 1 : page)

    useEffect(() => {
        localStorage.setItem("path", `/category/${category_title}/${category_id}`)
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
        {
            // categoryVideos && 
            <Results
                data = {categoryVideos}
                title = {category_title}
                loading = {loading}
                error = {error}
                setVideo = {props.setVideo}
                filterActive = {props.filterActive}
                setFilterActive = {props.setFilterActive}
                searchFunc = {getCategoryVideos}
                lengthFunc = {getCategoryVideosLength}
                page = {categoryPage}
                setPage = {setCategoryPage}
                val = {category_id}
                info = {info}
            />
        }
        </>
    );
}

export default CategoryResults;